export const SET_IMAGE_GROUPS = "SET_IMAGE_GROUPS"
